import BreadCrumb from "components/Common/BreadCrumb";
import TableContainer from "components/Common/TableContainer";
import en from "date-fns/locale/en-US";
import ko from "date-fns/locale/ko";
import moment from "moment";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Input,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
} from "reactstrap";
import { createSelector } from "reselect";
import {
  NumberParam,
  StringParam,
  useQueryParams,
  withDefault,
} from "use-query-params";
import LabelWrapper from "components/Common/LabelWrapper";
import CountUp from "react-countup";
import CollapseFilter from "components/Common/CollapseFilter";
import DatePickerCustom from "components/Common/DatePickerCustom";
import ModalPreview from "components/Common/ModalPreview";
import {
  COLOR_PLAN_PURCHASE_INVOICE_TYPE,
  COLOR_PLAN_PURCHASE_PAYMENT_METHOD,
  COLOR_PLAN_PURCHASE_PAYMENT_STATUS,
  COLOR_SOURCE_CHANNEL,
  COLOR_SOURCE_CREATOR,
  COLOR_USER_PLAN_PURCHASE_STATUS,
  ENUM_GATEWAY_PAYMENT_METHOD,
  ENUM_PLAN_PURCHASE_PAYMENT_METHOD,
  LIST_OPTION_SOURCE_CHANNEL,
  LIST_OPTION_SOURCE_CREATOR,
  LIST_PLAN_PURCHASE_INVOICE_TYPE,
  LIST_PLAN_PURCHASE_PAYMENT_METHOD,
  LIST_PLAN_PURCHASE_PAYMENT_METHOD_FILTER,
  LIST_PLAN_PURCHASE_PAYMENT_STATUS,
  LIST_USER_PLAN_PURCHASE_STATUS,
  PLAN_FEATURE_KEY_OPTION,
} from "helpers/constans";
import { formatDateStringToKorea, formatDateStringToUTC, formatNumber, formatNumberWithCommas } from "helpers/format";
import DropdownStatusNew from "components/Common/DropdownStatusNew";
import CopyWrapper from "components/Common/CopyWrapper";
import TooltipCustom from "components/Common/TooltipCustom";
import { Link } from "react-router-dom";
import UserPlanPurchaseDetail from "./UserPlanPurchaseDetail";
import ModalMultiPreviewImage from "components/Common/ModalMultiPreviewImage";
import { getUserPlanPurchases } from "store/user-plan-purchase/thunk";
import NO_IMAGE_USER from "../../assets/images/no-user.png";
import DropdownAsyncPlan from "components/Common/DropdownAsyncPlan";
import userPlanPurchaseApi from "api/userPlanPurchaseApi";
import JobForm from "pages/JobPost/JobForm";
import { benifitJobPostApi } from "api/jobPostApi";
import DropdownOptionNew from "components/Common/DropdownOptionNew";
import sectionApi from "api/sectionApi";
import noImageJob from "../../assets/images/no-job-post.png";
import regionApi from "api/regionApi";
import ModalConfirm from "components/Common/ModalConfirm";
import { CONFIG_OPTION_TOAST_ERROR, CONFIG_OPTION_TOAST_NORMAL } from "common/toast";
import plansApi from "api/planApi";

registerLocale("en", en);
registerLocale("ko", ko);

const UserPlanPurchaseList = () => {
  const { t, i18n } = useTranslation();
  const dispatch: any = useDispatch();

  const [query, setQuery]: any = useQueryParams({
    time_request: withDefault(NumberParam, 0),
    page: withDefault(NumberParam, 1),
    limit: withDefault(NumberParam, 30),
    jobTitle: withDefault(StringParam, ""),
    storeName: withDefault(StringParam, ""),
    fullName: withDefault(StringParam, ""),
    phoneNumber: withDefault(StringParam, ""),
    planId: withDefault(StringParam, ""),
    sectionId: withDefault(StringParam, ""),
    planPurchaseStatus: withDefault(StringParam, ""),
    paymentStatus: withDefault(StringParam, ""),
    paymentMethod: withDefault(StringParam, ""),
    invoiceType: withDefault(StringParam, ""),
    includeCreatedJobFromSystem: withDefault(StringParam, "false"),
    createdFrom: withDefault(StringParam, ""),
    createdTo: withDefault(StringParam, ""),
    paidFrom: withDefault(StringParam, ""),
    paidTo: withDefault(StringParam, ""),
  });

  const [storeNameSearch, setStoreNameSearch] = useState<string>(query?.storeName || "");
  const [jobTitleSearch, setJobTitleSearch] = useState<string>(query?.jobTitle || "");
  const [fullNameSearch, setFullNameSearch] = useState<string>(query?.fullName || "");
  const [phoneSearch, setPhoneSearch] = useState<string>(query?.phoneNumber || "");
  const [sectionSearch, setSectionSearch] = useState<string>(query?.sectionId || "");
  const [isShowBannerPremium, setIsShowBannerPremium] = useState<boolean>(false);
  const [itemToDelete, setItemToDelete] = useState<any>(false);
  const [isConfirmLoading, setIsConfirmLoading] = useState<boolean>(false);

  const [planSearch, setPlanSearch] = useState<any>({
    label: t("All Filter"),
    value: "all",
  })

  const [planPurchaseSearch, setPlanPurchaseSearch] = useState<string>(
    LIST_USER_PLAN_PURCHASE_STATUS?.find((item) => item?.value == query?.planPurchaseStatus)?.value ||
    ""
  );

  const [paymentStatusSearch, setPaymentStatusSearch] = useState<any | null>(
    LIST_PLAN_PURCHASE_PAYMENT_STATUS?.filter(
      (item) => String(item?.value) === String(query?.paymentStatus)
    )[0]?.value || ""
  );

  const [paymentMethodSearch, setPaymentMethodSearch] = useState<any>(
    LIST_PLAN_PURCHASE_PAYMENT_METHOD?.find(
      (item: any) => item?.value == query?.paymentMethod
    )?.value || ""
  );

  const [invoiceTypeSearch, setInvoiceTypeSearch] =
    useState<any>(
      LIST_PLAN_PURCHASE_INVOICE_TYPE?.find(
        (item: any) => item?.value == query?.invoiceType
      )?.value || ""
    );

  const [isIncludeSystemPostSearch, setIsIncludeSystemPostSearch] = useState<number>(
    query?.includeCreatedJobFromSystem || 0
  );

  const [dateSearch, setDateSearch] = useState<any[]>([
    query?.createdFrom
      ? moment(query?.createdFrom || "", "Y-MM-DD").toDate()
      : null,
    query?.createdTo ? moment(query?.createdTo || "", "Y-MM-DD").toDate() : null,
  ]);
  const [createdFrom, createdTo] = dateSearch;

  const [datePaidSearch, setDatePaidSearch] = useState<any[]>([
    query?.paidFrom
      ? moment(query?.paidFrom || "", "Y-MM-DD").toDate()
      : null,
    query?.paidTo ? moment(query?.paidTo || "", "Y-MM-DD").toDate() : null,
  ]);
  const [paidFrom, paidTo] = datePaidSearch;


  const [itemToEdit, setItemToEdit] = useState<any>(null);
  const [linkImage, setLinkImage] = useState<any>(null);
  const [summary, setSummary] = useState<any>(null);
  const [isOpenEditJobPost, setIsOpenEditJobPost] = useState<any>(false);
  const [itemEditJobPost, setItemEditJobPost] = useState<any>(null);
  const [dataBenifits, setDataBenifits] = useState<any>([]);
  const [dataConditions, setDataConditions] = useState<any>([]);
  const [dataRegions, setDataRegions] = useState<any>([]);
  const [dataSection, setDataSection] = useState<any>([]);
  const [dataPlan, setDataPlan] = useState<any>([]);

  const selectLayoutState = (state: any) => state.UserPlanPurchase;
  const UserProperties = createSelector(selectLayoutState, (state) => ({
    userPlanPurchases: state.userPlanPurchases,
    isUserPlanPurchaseLoading: state.isUserPlanPurchaseLoading,
    isUserPlanPurchaseSuccess: state.isUserPlanPurchaseSuccess,

    error: state.error,
  }));

  // Inside your component
  const { userPlanPurchases, isUserPlanPurchaseLoading } = useSelector(UserProperties);

  function loadTableData() {
    dispatch(getUserPlanPurchases(query));
  }

  const initSummary = async () => {
    try {
      const res = await userPlanPurchaseApi.getSummary(query);
      setSummary(res?.data);
    } catch (error) {
      console.log("error", error);
    }
  };

  useEffect(() => {
    loadTableData();
    initSummary();
  }, [dispatch, JSON.stringify(query)]);

  const searchData = () => {
    setQuery({
      ...query,
      jobTitle: encodeURIComponent(jobTitleSearch.trim()) || "",
      planPurchaseStatus: planPurchaseSearch || "",
      paymentStatus: paymentStatusSearch || "",
      fullName: fullNameSearch || "",
      phoneNumber: phoneSearch.trim() || "",
      storeName: storeNameSearch.trim() || "",
      planId: (planSearch?.value !== 'all' && planSearch) ? planSearch?.value : "",
      sectionId: sectionSearch || "",
      paymentMethod: paymentMethodSearch,
      invoiceType: invoiceTypeSearch,
      includeCreatedJobFromSystem: isIncludeSystemPostSearch === 1 ? "" : false,
      createdFrom: createdFrom
        ? formatDateStringToUTC(
          moment(new Date(createdFrom))
            .startOf("day")
            .format("Y-MM-DD HH:mm:ss")
        )
        : "",
      createdTo: createdTo
        ? formatDateStringToUTC(
          moment(new Date(createdTo)).endOf("day").format("Y-MM-DD HH:mm:ss")
        )
        : "",
      paidFrom: paidFrom
        ? formatDateStringToUTC(
          moment(new Date(paidFrom))
            .startOf("day")
            .format("Y-MM-DD HH:mm:ss")
        )
        : "",
      paidTo: paidTo
        ? formatDateStringToUTC(
          moment(new Date(paidTo)).endOf("day").format("Y-MM-DD HH:mm:ss")
        )
        : "",
      //sortBy: TYPE_SELECT_DEFAULT,
      page: 1,
      time_request: +new Date(),
    });
  };

  const resetData = () => {
    setQuery(
      {
        jobTitle: "",
        storeName: "",
        fullName: "",
        phoneNumber: "",
        planId: "",
        sectionId: "",
        planPurchaseStatus: "",
        paymentStatus: "",
        paymentMethod: "",
        invoiceType: "",
        includeCreatedJobFromSystem: "false",
        createdFrom: "",
        createdTo: "",
        paidFrom: "",
        paidTo: "",
        sortBy: "",
        time_request: +new Date(),
        page: 1,
      },
      "push"
    );

    setJobTitleSearch("");
    setPlanPurchaseSearch("");
    setPaymentStatusSearch("");
    setFullNameSearch("");
    setPhoneSearch((_prev) => "");
    setStoreNameSearch("");
    setPlanSearch("");
    setSectionSearch("");
    setPaymentMethodSearch("");
    setInvoiceTypeSearch("");
    setIsIncludeSystemPostSearch(0);
    setDateSearch([null, null]);
    setDatePaidSearch([null, null]);
  };

  // Begin::Update User
  const onCloseClick = () => {
    setItemToEdit(null);
  };

  const triggerRefresh = () => {
    // onCloseClick();
    loadTableData();
  };
  //End::Update User

  // Column
  const columns = useMemo(
    () => [
      {
        Header: t("No."),
        thWidth: 60,
        thClass: "whitespace-nowrap",
        Cell: ({ ...props }) => {
          return (
            <div style={{ width: 35 }}>
              {userPlanPurchases?.pagination?.total -
                ((query?.page - 1) * query?.limit + props?.row?.index)}
            </div>
          );
        },
      },
      {
        Header: t("Status"),
        accessor: "status",
        filterable: false,
        sortable: false,
        thWidth: 140,
        thClass: "text-center whitespace-nowrap",
        Cell: (cell: any) => {
          const status = cell?.value;
          return (
            <div className="text-center" style={{ minWidth: 80 }}>
              <span
                className={`rounded-pill badge bg-${COLOR_USER_PLAN_PURCHASE_STATUS[status] || "secondary"
                  }`}
              >
                {t(
                  LIST_USER_PLAN_PURCHASE_STATUS?.find(
                    (item: any) => String(item?.value) === String(status)
                  )?.label || ""
                )}
              </span>
            </div>
          );
        },
      },
      {
        Header: t("Payment Status"),
        accessor: "payment.status",
        filterable: false,
        sortable: false,
        thWidth: 140,
        thClass: "text-center whitespace-nowrap",
        Cell: (cell: any) => {
          const status = cell?.value;
          return (
            <div className="text-center" style={{ minWidth: 80 }}>
              <span
                className={`rounded-pill badge bg-${COLOR_PLAN_PURCHASE_PAYMENT_STATUS[status] || "secondary"
                  }`}
              >
                {t(
                  LIST_PLAN_PURCHASE_PAYMENT_STATUS?.find(
                    (item: any) => String(item?.value) === String(status)
                  )?.label || ""
                )}
              </span>
            </div>
          );
        },
      },
      {
        Header: t("User Recruiter"),
        accessor: "user",
        filterable: false,
        sortable: false,
        thWidth: 300,
        thClass: "whitespace-nowrap",
        Cell: (cell: any) => {
          const user = cell?.value as any;
          return (
            <div className="d-flex align-items-center gap-2">
              <div
                className="cursor-pointer overflow-hidden object-fit-cover"
                style={{
                  height: "45px",
                  width: "45px",
                  minWidth: "45px",
                }}
                onClick={() => setLinkImage(user?.profile?.imageUrls?.length > 1 ? { urls: user?.profile?.imageUrls } : { url: user?.profile?.imageUrls?.[0] || "" })}
              >
                <img
                  src={user?.profile?.imageUrls?.[0] || NO_IMAGE_USER}
                  alt={user?.profile?.nickname}
                  height={45}
                  width={45}
                  style={{
                    minWidth: "45px",
                    overflow: "hidden",
                    borderRadius: "100%",
                    objectFit: "cover",
                  }}
                  onError={({ currentTarget }) => {
                    currentTarget.onerror = null; // prevents looping
                    currentTarget.src = NO_IMAGE_USER;
                  }}
                />
              </div>
              <div>
                <div
                  style={{
                    wordBreak: "break-word"
                  }}
                >
                  {
                    user?.profile ? [user?.profile?.fullname, user?.profile?.phoneNumber].filter(Boolean).join(" - ") : (
                      user?.email ?? user?.providerId
                    )
                  }
                </div>
                <small className="text-secondary">{user?.store?.name}</small>
              </div>
            </div>
          );
        },
      },
      {
        Header: t("Plan"),
        accessor: "plan",
        filterable: true,
        sortable: false,
        thClass: "whitespace-nowrap",
        thWidth: 280,
        Cell: (cell: any) => {
          const item = cell?.row?.original;
          const plan = cell?.value;

          return plan ? <div className="d-flex gap-2 flex-column" style={{ minWidth: "250px" }}>
            <div>{plan?.info?.name}</div>
            <small>{plan?.info?.description}</small>
            <div className="cursor-pointer d-flex gap-2">
              {item?.features
                ? item?.features?.map((feature: any, index: number) => (
                  <span
                    className={`rounded-pill badge bg-primary`}
                    key={index}
                  >
                    {t(
                      PLAN_FEATURE_KEY_OPTION?.find(
                        (item: any) => String(item?.value) === String(feature?.featureKey)
                      )?.label || ""
                    )}
                  </span>
                ))
                : "-"}
            </div>
          </div> : '-';
        },
      },
      {
        Header: t("Section Name"),
        accessor: "section.name",
        filterable: true,
        sortable: false,
        thWidth: 150,
        thClass: " whitespace-nowrap",
        Cell: (cell: any) => {
          const item = cell?.row?.original;
          const dataSection = item?.banner ? item?.banner : item?.section;

          return (
            dataSection ? (
              <div className=" cursor-pointer" >
                {`${(dataSection?.fullName)} `}
              </div>
            ) : <div className="" >-</div>
          );
        },
      },
      {
        Header: t("Section Price"),
        accessor: "section1",
        filterable: true,
        sortable: false,
        thWidth: 150,
        thClass: "text-end whitespace-nowrap",
        Cell: (cell: any) => {
          const item = cell?.row?.original;
          const priceSection = item?.banner ? item?.banner?.price : item?.section?.price;
          const currency = item?.banner ? item?.banner?.currency : item?.section?.currency;

          return (
            priceSection ? (
              <div className="text-end cursor-pointer" >
                {`${formatNumberWithCommas(priceSection)} `}
                {currency === "KRW" ? "₩" : ""}
              </div>
            ) : <div className="text-end" >-</div>
          );
        },
      },
      {
        Header: `${t("Discount Section Rate")} (%)`,
        accessor: "discountRate",
        filterable: true,
        sortable: false,
        thClass: "align-middle whitespace-nowrap text-end",
        thWidth: 220,
        Cell: (cell: any) => {
          const item = cell?.row?.original;
          const discountRate = item?.banner ? item?.banner?.discountRate : item?.section?.discountRate;
          const priceType = cell?.row?.original?.priceType;

          return (
            <>
              <div className="cursor-pointer text-end" style={{ minWidth: "120px" }}>
                {(discountRate && priceType !== "FREE") ? `${formatNumber(discountRate)}%` : "-"}
              </div>
            </>
          );
        },
      },
      {
        Header: t("Section Final Price"),
        accessor: "section.price",
        filterable: true,
        sortable: false,
        thWidth: 150,
        thClass: "text-end whitespace-nowrap",
        Cell: (cell: any) => {
          const item = cell?.row?.original;
          const priceSection = item?.banner ? item?.banner?.price : item?.section?.price;
          const priceFinalSection = item?.banner ? item?.banner?.priceFinal : item?.section?.priceFinal;

          return (
            priceSection ? (
              <div className="text-end cursor-pointer" >
                {`${formatNumberWithCommas(priceFinalSection)} `}
                {item?.payment?.currency === "KRW" ? "₩" : ""}
              </div>
            ) : <div className="text-end" >-</div>
          );
        },
      },
      {
        Header: t("Plan Price"),
        accessor: "plan.price.price",
        filterable: true,
        sortable: false,
        thWidth: 150,
        thClass: "text-end whitespace-nowrap",
        Cell: (cell: any) => {
          const item = cell?.row?.original;
          return (
            cell?.value ? (
              <div className="text-end cursor-pointer" >
                {`${formatNumberWithCommas(cell?.value)} `}
                {item?.payment?.currency === "KRW" ? "₩" : ""}
              </div>
            ) : <div className="text-end" >-</div>
          );
        },
      },
      {
        Header: `${t("Discount Plan Rate")} (%)`,
        accessor: "plan.price.discountRate",
        filterable: true,
        sortable: false,
        thClass: "align-middle whitespace-nowrap text-end",
        thWidth: 180,
        Cell: (cell: any) => {
          const discountRate = cell?.value;
          const priceType = cell?.row?.original?.priceType;

          return (
            <>
              <div className="cursor-pointer text-end" style={{ minWidth: "120px" }}>
                {(discountRate && priceType !== "FREE") ? `${formatNumber(discountRate)}%` : "-"}
              </div>
            </>
          );
        },
      },
      {
        Header: t("Plan Final Price"),
        accessor: "plan.price",
        filterable: true,
        sortable: false,
        thClass: "align-middle whitespace-nowrap text-end",
        thWidth: 180,
        Cell: (cell: any) => {
          const item = cell?.row?.original?.plan?.price;
          const priceType = cell?.row?.original?.plan?.priceType;
          const currency = item?.currency === "KRW" ? "₩" : "$";
          const priceFinal = item?.priceFinal;

          return (
            <>
              <div className="cursor-pointer text-end" style={{ minWidth: "120px" }}>
                {(priceFinal && priceType !== "FREE") ? `${formatNumber(priceFinal)} ${currency}` : "-"}
              </div>
            </>
          );
        },
      },
      {
        Header: t("VAT (%)"),
        accessor: "plan.price.vatRate",
        filterable: true,
        sortable: false,
        thWidth: 120,
        thClass: "text-end whitespace-nowrap",
        Cell: (cell: any) => {
          return (
            <div className="text-end cursor-pointer">
              {cell?.value ? `${cell?.value}%` : "0"}
            </div>
          );
        },
      },
      {
        Header: t("Total Amount"),
        accessor: "payment.totalAmount",
        filterable: true,
        sortable: false,
        thWidth: 180,
        thClass: "text-end whitespace-nowrap",
        Cell: (cell: any) => {
          const item = cell?.row?.original;
          return (
            cell?.value ? (
              <div className="text-end cursor-pointer">
                {`${formatNumberWithCommas(cell?.value)} `}
                {item?.payment?.currency === "KRW" ? "₩" : ""}
              </div>
            ) : <div className="text-end cursor-pointer">-</div>
          );
        },
      },
      {
        Header: t("Job Title"),
        accessor: "userDevice.ipAddress",
        thClass: "whitespace-nowrap",
        filterable: true,
        sortable: false,
        thWidth: 240,
        Cell: (cell: any) => {
          const item = cell?.row?.original;
          // const jobTitle = item?.features?.length > 0 ? item?.features?.find((feature: any) => feature?.featureKey === "POST_JOB") : "";
          const jobPost = item?.jobPost;
          const sourceCreator = jobPost?.sourceCreator || "";
          const sourceChannel = jobPost?.sourceChannel || "";

          return jobPost ? (
            <div className="cursor-pointer text-primary" style={{ minWidth: 220 }}>
              <CopyWrapper contentCopy={jobPost?.title} >
                <span
                  className="flex"
                  onClick={() => {
                    setItemEditJobPost(jobPost)
                    setIsOpenEditJobPost(true)
                  }}
                >
                  {`${jobPost?.title || ""}`}
                </span>
              </CopyWrapper>
              <div className="d-flex gap-2 mt-2">
                <span
                  className={`rounded-pill badge bg-${COLOR_SOURCE_CREATOR[sourceCreator] || "secondary"}`}
                >
                  {t(
                    LIST_OPTION_SOURCE_CREATOR?.find(
                      (item: any) => String(item?.value) === String(sourceCreator)
                    )?.label || ""
                  )}
                </span>

                <span
                  className={`rounded-pill badge bg-${COLOR_SOURCE_CHANNEL[sourceChannel] || "secondary"}`}
                >
                  {t(
                    LIST_OPTION_SOURCE_CHANNEL?.find(
                      (item: any) => String(item?.value) === String(sourceChannel)
                    )?.label || ""
                  )}
                </span>
              </div>
            </div>
          ) : '-';
        },
      },
      {
        Header: t("Start Date"),
        accessor: "startDate",
        filterable: true,
        sortable: false,
        thWidth: 130,
        thClass: "text-end whitespace-nowrap",
        Cell: (cell: any) => {
          const date = cell?.value ? moment.utc(cell?.value).format("YYYY-MM-DD") : "";

          return (
            <div className="text-end" style={{ minWidth: "100px" }}>
              <span>{date || "-"}</span> <br />{" "}
            </div>
          );
        },
      },
      {
        Header: t("End Date"),
        accessor: "endDate",
        filterable: true,
        sortable: false,
        thWidth: 130,
        thClass: "text-end whitespace-nowrap",
        Cell: (cell: any) => {
          const date = cell?.value ? moment.utc(cell?.value).format("YYYY-MM-DD") : "";
          
          return (
            <div className="text-end" style={{ minWidth: "100px" }}>
              <span>{date || "-"}</span> <br />{" "}
            </div>
          );
        },
      },
      {
        Header: t("Payment Method"),
        accessor: "payment.method",
        filterable: false,
        sortable: false,
        thWidth: 180,
        thClass: "text-center whitespace-nowrap",
        Cell: (cell: any) => {
          const item = cell?.row?.original;
          let status = cell?.value;

          if (item?.payment?.gatewayPaymentMethod === ENUM_GATEWAY_PAYMENT_METHOD.VIRTUALACCOUNT) {
            status = ENUM_PLAN_PURCHASE_PAYMENT_METHOD.TRANSFER_VIRTUAL_ACCOUNT
          }

          return (
            <div className="text-center" style={{ minWidth: 80 }}>
              <span
                className={`rounded-pill badge bg-${COLOR_PLAN_PURCHASE_PAYMENT_METHOD[status] || "secondary"
                  }`}
              >
                {t(
                  LIST_PLAN_PURCHASE_PAYMENT_METHOD?.find(
                    (item: any) => (item?.value) == (status)
                  )?.label || ""
                )}
              </span>
            </div>
          );
        },
      },
      {
        Header: t("Invoice Type"),
        accessor: "payment.transfer.receiptType",
        filterable: false,
        sortable: false,
        thWidth: 140,
        thClass: "text-center whitespace-nowrap",
        Cell: (cell: any) => {
          let type = cell?.value;
          const item: any = cell?.row?.original;
          if (item?.payment?.method === ENUM_PLAN_PURCHASE_PAYMENT_METHOD.GATEWAY) {
            type = item?.payment?.receiptType;
          }

          return type ? (
            <div className="text-center" style={{ minWidth: 80 }}>
              <span
                className={`rounded-pill badge bg-${COLOR_PLAN_PURCHASE_INVOICE_TYPE[type] || "secondary"
                  }`}
              >
                {t(
                  LIST_PLAN_PURCHASE_INVOICE_TYPE?.find(
                    (item: any) => (item?.value) == (type)
                  )?.label || ""
                )}
              </span>
            </div>
          ) : <div className="text-center" style={{ minWidth: 80 }}>-</div>;
        },
      },
      // {
      //   Header: t("Banner Premium"),
      //   accessor: "jobPost.sectionItems",
      //   thClass: "text-center whitespace-nowrap",
      //   filterable: true,
      //   sortable: false,
      //   thWidth: 120,
      //   Cell: (cell: any) => {
      //     const item = cell?.row?.original;
      //     const bannerPositions = (cell?.value || [])
      //       .filter((item: any) => (item?.bannerPositionId && item?.bannerImage));
      //     const bannerPremium = bannerPositions?.[0]?.bannerImage || "" ;
          
      //     return  (
      //       <div className="w-100 text-center " style={{ minWidth: "80px" }}>
      //         {
      //           (item?.status === "ACTIVE" && item?.banner) ? (
      //             <div
      //               style={{ width: "80px" }}
      //               className="m-auto cursor-pointer"
      //               onClick={() => {
      //                 setIsShowBannerPremium(true)
      //                 setLinkImage({ url: bannerPremium })
      //               }}
      //             >
      //               <img
      //                 src={bannerPremium ?? noImageJob}
      //                 width={70}
      //                 height={70}
      //                 className=""
      //                 style={{ objectFit: "contain" }}
      //                 alt="thumbnail"
      //                 onError={({ currentTarget }) => {
      //                   currentTarget.onerror = null; // prevents looping
      //                   currentTarget.src = noImageJob;
      //                 }}
      //               />
      //             </div>
      //           ) : "-"
      //         }
      //       </div>
      //     )
      //   },
      // },
      {
        Header: t("Paid at"),
        accessor: "payment.paidAt",
        filterable: true,
        sortable: false,
        thWidth: 130,
        thClass: "text-end whitespace-nowrap",
        Cell: (cell: any) => {
          const date = formatDateStringToKorea(cell?.value);
          const arrDate = String(date || "").split(" ");

          return (
            <div className="text-end" style={{ minWidth: "100px" }}>
              <span>
                <span>{arrDate?.[0] || ""}</span> <br />{" "}
                <span className="text-secondary">{arrDate?.[1] || "-"}</span>{" "}
              </span>
            </div>
          );
        },
      },
      {
        Header: t("Created at"),
        accessor: "createdAt",
        filterable: true,
        sortable: false,
        thWidth: 130,
        thClass: "text-end whitespace-nowrap",
        Cell: (cell: any) => {
          const date = formatDateStringToKorea(cell?.value);
          const arrDate = String(date || "").split(" ");

          return (
            <div className="text-end" style={{ minWidth: "100px" }}>
              <span>
                <span>{arrDate?.[0] || ""}</span> <br />{" "}
                <span className="text-secondary">{arrDate?.[1] || "-"}</span>{" "}
              </span>
            </div>
          );
        },
      },
      {
        Header: t("Action"),
        thClass: "text-center",
        thWidth: 120,
        Cell: (cell: any) => {
          const item: any = cell?.row?.original;
          return (
            <ul className="list-inline flex-wrap justify-content-center hstack gap-2 mb-0">
              <TooltipCustom
                title={t("Detail Payment History")}
                id={`detail-${item?.id}`}
              >
                <Link
                  className="btn btn-sm btn-soft-primary edit-item-btn"
                  to="#"
                  onClick={(e) => {
                    e.preventDefault();
                    setItemToEdit(item);
                  }}
                >
                  <i className="ri-eye-fill align-bottom"></i>
                </Link>
              </TooltipCustom>

              {/* <TooltipCustom
                title={t('Delete Payment History')}
                id={`detail-cp-${item?.id}`}
              >
                <Link
                  className="btn btn-sm btn-soft-danger edit-item-btn"
                  to="#"
                  onClick={(e: any) => {
                    e.preventDefault();
                    setItemToDelete(item);
                  }}
                >
                  <i className="ri-delete-bin-3-fill align-bottom"></i>
                </Link>
              </TooltipCustom> */}
            </ul>
          );
        },
      },
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [i18n?.language, userPlanPurchases?.pagination?.total, query?.page]
  );

  const handleChangePage = useCallback((page: any) => {
    setQuery({ page: page + 1 });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChangeSorting = useCallback((sortBy: any) => {
    setQuery((_prev: any) => {
      return { ..._prev, ...sortBy };
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChangePicker = (values: any[] = []) => {
    setDateSearch((_prev: any) => values);
  };

  const handleChangePaidDatePicker = (values: any[] = []) => {
    setDatePaidSearch((_prev: any) => values);
  };

  const onCloseImageClick = () => {
    setLinkImage(null);
    setIsShowBannerPremium(false);
  };

  const onCloseJobPostClick = () => {
    setIsOpenEditJobPost(false)
    setItemEditJobPost(null)
  }

  const handleActionDelete = async (id: any) => {
    if (!id) return;

    try {
      setIsConfirmLoading((_prev) => true);
      const response: any = await userPlanPurchaseApi.deletePaymentHistory(id);
      if (response?.code) {
        setIsConfirmLoading((_prev) => false);
        loadTableData();
        setItemToDelete(false);
        toast(
          `${t("The payment history has been deleted.")}`,
          CONFIG_OPTION_TOAST_NORMAL
        );
      } else {
        setIsConfirmLoading((_prev) => false);
        toast(`${response}`, CONFIG_OPTION_TOAST_ERROR);
      }
    } catch (error: any) {
      setIsConfirmLoading((_prev) => false);
      toast(`${error?.message || ""}`, CONFIG_OPTION_TOAST_ERROR);
      return error;
    }
  };

  useEffect(() => {
    const handleCallAllOption = async () => {
      try {
        const [resBenifitCondition, resSections, resRegions, resPlans]: any = await Promise.all([
          benifitJobPostApi.benifitActive(),
          sectionApi.getSections(),
          regionApi.getRegions(),
          plansApi.getPlans()
        ]);
        if (resBenifitCondition?.data) {
          setDataBenifits(resBenifitCondition?.data?.benefits || [])
          setDataConditions(resBenifitCondition?.data?.preferences || [])
        }

        if (resSections?.data) {
          const formatDataSection = resSections?.data?.map((item: any) => ({
            label: item?.fullName,
            value: item?.id,
            data: item
          }))
          setDataSection(formatDataSection)
        }

        if (resRegions?.data) {
          const formatRegions = resRegions?.data?.map((item: any) => {
            const formatSubRegion = item?.subRegions?.map((sub: any) => {
              return {
                value: sub?.id,
                label: sub?.name
              }
            })
            return {
              value: item?.id,
              label: item?.name,
              children: formatSubRegion || []
            }
          })
          setDataRegions(formatRegions)
        }
        
        if (resPlans?.data) {
          const formatDataPlan = resPlans?.data?.items?.map((item: any) => {
            return {
              label: item?.info?.name,
              value: item?.id,
              data: item,
          }})
          setDataPlan(formatDataPlan)
        }

      } catch (error: any) {
        return error;
      }
    };
    handleCallAllOption();
  }, []);

  useEffect(() => {
    document.title = `${t("Payment History")} | OnnyJob`;
    document.body.classList.remove("vertical-sidebar-enable");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [i18n?.language]);


  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb title={t("Payment History")} pageTitle={t("Home")} />
          <Row>
            <Col lg={12}>
              <Card
                id="customerList"
                style={{ boxShadow: "0px 3px 4px 0px rgba(0, 0, 0, 0.03)" }}
              >
                <CardHeader className="border-0">
                  <div className="d-block d-xl-flex justify-content-between align-items-start">
                    <div
                      className="d-flex w-100 flex-wrap gap-3 gap-md-2 menu-card-statistics justify-content-start mb-3 mb-xl-2 position-relative"
                      style={{ maxWidth: "100%" }}
                    >
                      <Card className="card-animate mb-0 me-0 me-md-2 mb-1 bg-primary-subtle text-primary border-0">
                        <CardBody className="p-3">
                          <div className="d-flex align-items-center ">
                            <div className="flex-grow-1 overflow-hidden">
                              <p className="text-uppercase fw-medium text-primary text-truncate fs-12 mb-0">
                                {t("Total")}
                              </p>
                            </div>
                          </div>
                          <div className="d-flex align-items-end justify-content-between mt-2 pt-0">
                            <div>
                              <h4 className="fs-20 fw-semibold ff-secondary mb-0">
                                <span className="counter-value text-primary">
                                  <CountUp
                                    start={0}
                                    end={summary?.total || 0}
                                    duration={1}
                                  />
                                </span>
                              </h4>
                            </div>
                          </div>
                        </CardBody>
                      </Card>

                      <Card className="card-animate mb-0 me-0 me-md-2 mb-1 bg-primary-subtle text-primary border-0">
                        <CardBody className="p-3">
                          <div className="d-flex align-items-center ">
                            <div className="flex-grow-1 overflow-hidden">
                              <p className="text-uppercase fw-medium text-primary text-truncate fs-12 mb-0">
                                {t("Total Pending")}
                              </p>
                            </div>
                          </div>
                          <div className="d-flex align-items-end justify-content-between mt-2 pt-0">
                            <div>
                              <h4 className="fs-20 fw-semibold ff-secondary mb-0">
                                <span className="counter-value text-primary">
                                  <CountUp
                                    start={0}
                                    end={
                                      summary?.PENDING || 0
                                    }
                                    duration={1}
                                  />
                                </span>
                              </h4>
                            </div>
                          </div>
                        </CardBody>
                      </Card>

                      <Card className="card-animate mb-0 me-0 me-md-2 mb-1 bg-primary-subtle text-primary border-0">
                        <CardBody className="p-3">
                          <div className="d-flex align-items-center ">
                            <div className="flex-grow-1 overflow-hidden">
                              <p className="text-uppercase fw-medium text-primary text-truncate fs-12 mb-0">
                                {t("Total Active")}
                              </p>
                            </div>
                          </div>
                          <div className="d-flex align-items-end justify-content-between mt-2 pt-0">
                            <div>
                              <h4 className="fs-20 fw-semibold ff-secondary mb-0">
                                <span className="counter-value text-primary">
                                  <CountUp
                                    start={0}
                                    end={
                                      summary?.ACTIVE || 0
                                    }
                                    duration={1}
                                  />
                                </span>
                              </h4>
                            </div>
                          </div>
                        </CardBody>
                      </Card>

                      <Card className="card-animate mb-0 me-0 me-md-2 mb-1 bg-primary-subtle text-primary border-0">
                        <CardBody className="p-3">
                          <div className="d-flex align-items-center ">
                            <div className="flex-grow-1 overflow-hidden">
                              <p className="text-uppercase fw-medium text-primary text-truncate fs-12 mb-0">
                                {t("Total Expired")}
                              </p>
                            </div>
                          </div>
                          <div className="d-flex align-items-end justify-content-between mt-2 pt-0">
                            <div>
                              <h4 className="fs-20 fw-semibold ff-secondary mb-0">
                                <span className="counter-value text-primary">
                                  <CountUp
                                    start={0}
                                    end={
                                      summary?.EXPERIED || 0
                                    }
                                    duration={1}
                                  />
                                </span>
                              </h4>
                            </div>
                          </div>
                        </CardBody>
                      </Card>

                      <Card className="card-animate mb-0 me-0 me-md-2 mb-1 bg-primary-subtle text-primary border-0">
                        <CardBody className="p-3">
                          <div className="d-flex align-items-center ">
                            <div className="flex-grow-1 overflow-hidden">
                              <p className="text-uppercase fw-medium text-primary text-truncate fs-12 mb-0">
                                {t("Total Revoked")}
                              </p>
                            </div>
                          </div>
                          <div className="d-flex align-items-end justify-content-between mt-2 pt-0">
                            <div>
                              <h4 className="fs-20 fw-semibold ff-secondary mb-0">
                                <span className="counter-value text-primary">
                                  <CountUp
                                    start={0}
                                    end={
                                      summary?.REVOKED || 0
                                    }
                                    duration={1}
                                  />
                                </span>
                              </h4>
                            </div>
                          </div>
                        </CardBody>
                      </Card>
                    </div>
                  </div>
                </CardHeader>
                <div className=" border border-dashed border-end-0 border-start-0 card-body mt-0 pb-4">
                  <CollapseFilter>
                    <Row className="g-4 align-items-center mt-0 mt-md-2">
                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-2"
                      >
                        <LabelWrapper label={t("Job Title")} isShow={!!jobTitleSearch}>
                          <Input
                            type="text"
                            className="form-control search"
                            placeholder={`${t("Job Title")}...`}
                            value={jobTitleSearch}
                            onChange={(e) => setJobTitleSearch(e.target.value)}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-2"
                      >
                        <LabelWrapper label={t("Store Name")} isShow={!!storeNameSearch}>
                          <Input
                            type="text"
                            className="form-control search"
                            placeholder={`${t("Store Name")}...`}
                            value={storeNameSearch}
                            onChange={(e) => setStoreNameSearch(e.target.value)}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-2"
                      >
                        <LabelWrapper
                          isShow={!!fullNameSearch}
                          label={`${t("Full Name")}`}
                        >
                          <Input
                            type="text"
                            className="form-control search"
                            placeholder={`${t("Full Name")}...`}
                            value={fullNameSearch}
                            onChange={(e) => setFullNameSearch(e.target.value)}
                            onKeyDown={(e) => {
                              if (e.key === "Enter") {
                                searchData();
                              }
                            }}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-2"
                      >
                        <LabelWrapper
                          label={`${t("Phone Number")}`}
                          isShow={!!phoneSearch}
                        >
                          <Input
                            type="text"
                            className="form-control search"
                            placeholder={`${t("Phone Number")}...`}
                            value={phoneSearch}
                            onChange={(e) => setPhoneSearch(e.target.value)}
                            onKeyDown={(e) => {
                              if (e.key === "Enter") {
                                searchData();
                              }
                            }}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-3"
                      >
                        <LabelWrapper label={t("Plan")} isShow={true}>
                          <DropdownAsyncPlan
                            name="plan"
                            placeholder={`${t("Plan")}...`}
                            listCheckedOption={planSearch}
                            onChangeSelect={(event: any) =>
                              setPlanSearch(event)
                            }
                            isAllOption={true}
                            hideSelectedOptions={true}
                            isMulti={false}
                            isClearable={false}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-3"
                      >
                        <LabelWrapper label={t("Section")} isShow={true}>
                          <DropdownOptionNew
                            name="provider"
                            dataList={dataSection || []}
                            placeholder={`${t("Section")}...`}
                            className="dropdown-status-rounded"
                            classNamePrefix="name-prefix"
                            initialValue={sectionSearch}
                            onChangeSelect={(e: any) =>
                              setSectionSearch(e?.value)
                            }
                            isHasOptionAll={true}
                            optionAll={{ label: t("All Filter"), value: "" }}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-3"
                      >
                        <LabelWrapper label={t("Plan Purchase Status")} isShow={true}>
                          <DropdownStatusNew
                            name="paymentMethod"
                            dataList={LIST_USER_PLAN_PURCHASE_STATUS || []}
                            placeholder={`${t("Plan Purchase Status")}...`}
                            className="dropdown-status-rounded"
                            classNamePrefix="name-prefix"
                            initialValue={planPurchaseSearch}
                            onChangeSelect={(event: any) =>
                              setPlanPurchaseSearch(event?.value)
                            }
                            isHasOptionAll={true}
                            optionAll={{ label: t("All Filter"), value: "" }}
                            colors={COLOR_USER_PLAN_PURCHASE_STATUS}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-3"
                      >
                        <LabelWrapper label={t("Payment Status")} isShow={true}>
                          <DropdownStatusNew
                            name="paymentStatus"
                            dataList={LIST_PLAN_PURCHASE_PAYMENT_STATUS || []}
                            placeholder={`${t("Payment Status")}...`}
                            className="dropdown-status-rounded"
                            classNamePrefix="name-prefix"
                            initialValue={paymentStatusSearch || ""}
                            onChangeSelect={(e: any) => setPaymentStatusSearch(e?.value)}
                            isHasOptionAll={true}
                            optionAll={{ label: t("All Filter"), value: "" }}
                            colors={COLOR_PLAN_PURCHASE_PAYMENT_STATUS}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-3"
                      >
                        <LabelWrapper label={t("Payment Method")} isShow={true}>
                          <DropdownStatusNew
                            name="paymentMethod"
                            dataList={LIST_PLAN_PURCHASE_PAYMENT_METHOD_FILTER || []}
                            placeholder={`${t("Payment Method")}...`}
                            className="dropdown-status-rounded"
                            classNamePrefix="name-prefix"
                            initialValue={paymentMethodSearch}
                            onChangeSelect={(event: any) =>
                              setPaymentMethodSearch(event?.value)
                            }
                            isHasOptionAll={true}
                            optionAll={{ label: t("All Filter"), value: "" }}
                            colors={COLOR_PLAN_PURCHASE_PAYMENT_METHOD}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-3"
                      >
                        <LabelWrapper
                          label={t("Invoice Type")}
                          isShow={true}
                        >
                          <DropdownStatusNew
                            name="invoiceType"
                            dataList={LIST_PLAN_PURCHASE_INVOICE_TYPE || []}
                            placeholder={`${t("Invoice Type")}...`}
                            className="dropdown-status-rounded"
                            classNamePrefix="name-prefix"
                            initialValue={invoiceTypeSearch}
                            onChangeSelect={(e: any) =>
                              setInvoiceTypeSearch(e?.value)
                            }
                            isHasOptionAll={true}
                            optionAll={{ label: t("All Filter"), value: "" }}
                            colors={COLOR_PLAN_PURCHASE_INVOICE_TYPE}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-sm-4 mt-md-3 mt-3 date-picker-wrapper-custom"
                      >
                        <LabelWrapper
                          label={t("Date Range (Create)")}
                          isShow={!!createdFrom || !!createdTo}
                        >
                          <DatePickerCustom
                            startDate={createdFrom || null}
                            endDate={createdTo || null}
                            onChangePicker={handleChangePicker}
                            placeholder={t("Date Create")}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-sm-4 mt-md-3 mt-3 date-picker-wrapper-custom"
                      >
                        <LabelWrapper
                          label={t("Date Range (Paid)")}
                          isShow={!!paidFrom || !!paidTo}
                        >
                          <DatePickerCustom
                            startDate={paidFrom || null}
                            endDate={paidTo || null}
                            onChangePicker={handleChangePaidDatePicker}
                            placeholder={t("Date Paid")}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        lg={3}
                        className="hstack gap-1 justify-content-center justify-content-md-end mt-sm-4 mt-md-3 d-flex"
                      >
                        <LabelWrapper label={t("Include System Post")} isShow={true} style={{flex: 1}}>
                          <div
                            className="form-check form-switch form-switch-sm text-center"
                            dir="ltr"
                            style={{
                              paddingTop: 10,
                              paddingLeft: 10,
                            }}
                          >
                            <input
                              type="checkbox"
                              className="form-check-input"
                              name="include-system-post"
                              checked={isIncludeSystemPostSearch === 1}
                              style={{ marginLeft: 0 }}
                              onChange={(e) => {
                                const value = e?.target?.checked;
                                setIsIncludeSystemPostSearch(value === true ? 1 : 0);
                              }}
                            />
                          </div>
                        </LabelWrapper>
                      </Col>
                      <Col
                        sm={12}
                        md={9}
                        lg={9}
                        className="hstack gap-1 justify-content-center justify-content-md-end mt-sm-4 mt-md-3 d-flex"
                      >
                        <div>
                          <button
                            type="button"
                            className="btn btn-primary me-1"
                            onClick={searchData}
                          >
                            <i className="ri-search-line align-bottom me-1"></i>{" "}
                            {t("Button Search")}
                          </button>
                          <button
                            type="button"
                            className="btn btn-secondary fs-14"
                            onClick={resetData}
                          >
                            <i className="ri-refresh-line align-bottom me-1"></i>{" "}
                            {t("Button Reset")}
                          </button>
                        </div>
                      </Col>
                    </Row>
                  </CollapseFilter>
                </div>
                <CardBody className="pt-3">
                  <div>
                    <TableContainer
                      className="custom-header-css"
                      divClass="table-responsive table-card"
                      tableClass="align-middle table-bordered-dashed sticky-table-user-plan-purchase"
                      theadClass="table-light text-muted"
                      columns={columns}
                      data={userPlanPurchases?.items?.length ? userPlanPurchases?.items : []}
                      customPageSize={query.limit}
                      customPageIndex={query.page - 1}
                      totalRecords={userPlanPurchases?.pagination?.total}
                      customPageCount={Math.ceil(
                        Number(userPlanPurchases?.pagination?.total) / Number(query.limit)
                      )}
                      handleChangePage={handleChangePage}
                      manualSorting={true}
                      sorting={{
                        sortBy: query.sortBy,
                        orderBy: query.orderBy,
                      }}
                      handleChangeSorting={handleChangeSorting}
                      isLoading={isUserPlanPurchaseLoading}
                    />
                  </div>
                  <ToastContainer closeButton={false} limit={1} />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>

        <Modal isOpen={isOpenEditJobPost} centered={true} size="xl" scrollable={true}>
          <ModalHeader toggle={onCloseJobPostClick}>
            <>
              {!!itemEditJobPost?.id
                ? t("Button Update Job Post")
                : t("Button Create Job Post")}
            </>{" "}
            <>
              {itemEditJobPost?.id && (" - " + (itemEditJobPost?.title || "") || "")}
            </>
          </ModalHeader>
          <ModalBody>
            <div style={{ minHeight: "calc(100dvh - 200px)" }} className="mt-1">
              <JobForm
                id={String(itemEditJobPost?.id || "")}
                dataBenifits={dataBenifits}
                dataConditions={dataConditions}
                dataRegions={dataRegions}
                dataSection={dataSection}
                dataPlan={dataPlan}
                triggerRefresh={triggerRefresh}
                onClose={onCloseJobPostClick}
              />
            </div>
          </ModalBody>
        </Modal>

        {
          itemToEdit && (
            <UserPlanPurchaseDetail
              // isOpen={!!itemToEdit}
              isOpen={true}
              item={itemToEdit}
              onClose={onCloseClick}
              triggerRefresh={triggerRefresh}
              setLinkImage={setLinkImage}
            />
          )
        }

        {itemToDelete && (
          <ModalConfirm
            header={t("Delete Payment History")}
            isOpen={itemToDelete}
            isLoading={isConfirmLoading}
            onClose={() => setItemToDelete(false)}
            onConfirm={() => handleActionDelete(itemToDelete?.id)}
          />
        )}

        <ModalPreview
          type={linkImage?.isVideo ? "VIDEO" : "IMAGE"}
          isOpen={!!linkImage?.url}
          url={linkImage?.url}
          content={linkImage?.content}
          onClose={() => onCloseImageClick()}
          isBannerPremium={isShowBannerPremium}
        />

        <ModalMultiPreviewImage
          isOpen={!!linkImage?.urls}
          urls={linkImage?.urls || []}
          onClose={() => onCloseImageClick()}
        />
      </div>
    </React.Fragment>
  );
};

export default UserPlanPurchaseList;
